module.exports = function (_, Class, $, M) {
  'use strict';

  var HoverCard,
    settings = {
      mouseleave_threshold: 500,
      trigger_spacing: 20,
    },
    selectors = {
      hovercard: '.hovercard',
    },
    class_names = {
      directions: {
        left: 'hovercard-left',
        right: 'hovercard-right',
        top: 'hovercard-top',
        bottom: 'hovercard-bottom',
      },
    };

  HoverCard = Class.create({
    initialize: function ($trigger, user, direction) {
      this.user = user;
      this.direction = direction || 'right';
      this.$trigger = $trigger;
      this.update();
    },

    set_user: function (user) {
      this.user = user;
      this.update();
    },

    update: function () {
      if (this.$card) {
        this.destroy();
      }
      this.$card = this.render();
      this.align();
      this.$elements = this.$card.add(this.$trigger);
      this.$elements.data('hovercard', this);
      this.bind();
    },

    render: function () {
      var mus_user = null;

      if (this.user) {
        mus_user = M.users.get_context(this.user);
        mus_user = this.setUpBadgeInfo(mus_user);
      }

      var $card = $(
        MEMRISE.renderer.render('hovercard', { the_user: mus_user }),
      );
      $card.appendTo('body');

      $('*[data-toggle="tooltip"]').tooltip();

      return $card;
    },

    setUpBadgeInfo: function (user_data) {
      var badges = user_data.badges;

      if (badges.goal_streak) {
        var level = badges.goal_streak.level % 35,
          color = '';

        if (level > 29) color = 'c5';
        else if (level > 19) color = 'c4';
        else if (level > 14) color = 'c3';
        else if (level > 6) color = 'c2';
        else if (level > 2) color = 'c1';
        else color = 'c0';

        user_data.badges.goal_streak.color = color;
      }

      return user_data;
    },

    get_alignment: function (direction) {
      var trigger_pos = this.$trigger.offset(),
        x = 0,
        y = 0;

      if (direction === 'top' || direction === 'bottom') {
        x =
          trigger_pos.left +
          (this.$trigger.outerWidth() - this.$card.outerWidth()) / 2;

        if (direction === 'top') {
          y =
            trigger_pos.top -
            this.$card.outerHeight() -
            settings.trigger_spacing;
        } else {
          y =
            trigger_pos.top +
            this.$trigger.outerHeight() +
            settings.trigger_spacing;
        }
      }

      if (direction === 'left' || direction === 'right') {
        y =
          trigger_pos.top +
          (this.$trigger.outerHeight() - this.$card.outerHeight()) / 2;

        if (direction === 'left') {
          x =
            trigger_pos.left -
            this.$card.outerWidth() -
            settings.trigger_spacing;
        } else {
          x =
            trigger_pos.left +
            this.$trigger.outerWidth() +
            settings.trigger_spacing;
        }
      }

      return {
        x: x,
        y: y,
      };
    },

    align: function () {
      var pos = this.get_alignment(this.direction),
        win = $(window),
        win_width = win.width(),
        win_height = win.height(),
        win_origin_x = win.scrollLeft(),
        win_origin_y = win.scrollTop(),
        re_align = false,
        used_direction = this.direction,
        i;

      if (this.direction === 'left' && pos.x < win_origin_x) {
        re_align = 'right';
      } else if (
        this.direction === 'right' &&
        pos.x + this.$card.outerWidth() > win_origin_x + win_width
      ) {
        re_align = 'left';
      } else if (this.direction === 'top' && pos.y < win_origin_y) {
        re_align = 'bottom';
      } else if (
        this.direction === 'bottom' &&
        pos.y + this.$card.outerHeight() > win_origin_y + win_height
      ) {
        re_align = 'top';
      }

      if (re_align) {
        pos = this.get_alignment(re_align);
        used_direction = re_align;
      }

      for (i = 0; i < class_names.directions.length; i += 1) {
        this.$card.removeClass(class_names.directions[i]);
      }
      this.$card.addClass(class_names.directions[used_direction]);

      this.$card.css({ left: pos.x, top: pos.y });
    },

    bind: function () {
      var self = this;

      this.$elements.on('mouseenter', function () {
        self.on_mouse_enter();
      });

      this.$elements.on('mouseleave', function () {
        self.on_mouse_leave();
      });
    },

    destroy: function () {
      this.$elements.off('mouseenter').off('mouseleave');
      this.$card.remove();
      this.$trigger.removeData('hovercard');
    },

    on_mouse_enter: function () {
      if (this.hover_timer) {
        clearTimeout(this.hover_timer);
      }
    },

    on_mouse_leave: function () {
      var self = this;

      if (this.hover_timer) {
        clearTimeout(this.hover_timer);
      }

      this.hover_timer = setTimeout(function () {
        self.destroy();
      }, settings.mouseleave_threshold);
    },
  });

  if (!_.has(M, 'ui')) {
    M.ui = {};
  }
  M.ui.HoverCard = HoverCard;

  // Bindings
  var cached_users = {};

  M.renderer.ready(function () {
    $(document).on(
      'mouseenter',
      '[data-role="hovercard"][data-user-id]:visible',
      function () {
        var $trigger = $(this),
          user_id = parseInt($trigger.dataAttr('user-id'), 10),
          dir = $trigger.dataAttr('direction'),
          hovercard,
          user = null;

        if (cached_users.hasOwnProperty(user_id)) {
          user = cached_users[user_id];
        }

        if (typeof $trigger.data('hovercard') === 'undefined') {
          $(selectors.hovercard).each(function () {
            $(this).data('hovercard').destroy();
          });
          hovercard = new M.ui.HoverCard($trigger, user, dir);
        } else {
          hovercard = $trigger.data('hovercard');
        }

        if (user === null) {
          $.ajax({
            url: '/api/user/get/',
            type: 'GET',
            data: { user_id: user_id, with_leaderboard: true },
            success: function (data) {
              cached_users[user_id] = data.user;
              hovercard.set_user(data.user);
            },
          });
        }
      },
    );
  });

  _(M.users).on('follow-press', function (data) {
    // Update our knowledge about this user, importantly follow status.
    if (_.has(cached_users, data.user.id)) {
      cached_users[data.user.id] = $.extend(
        cached_users[data.user.id],
        data.user,
      );
    }
  });
};
